import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ArrowUpRight } from '@phosphor-icons/react';
import { FEATURED_SEO_LIST, TOP_LEVEL_SEO_LIST as SEO_LIST } from '../lib/seoPages';

export function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-neutral-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <div className="w-8 h-8 bg-neutral-900 text-white flex items-center justify-center">
            <Compass size={18} weight="bold" />
          </div>
          <span className="font-display text-xl tracking-tight">PendelPilot</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm">
          <Link to="/pendelkostenrechner" className="hover:underline underline-offset-4">Pendelkosten</Link>
          <Link to="/homeoffice-rechner" className="hover:underline underline-offset-4">Homeoffice</Link>
          <Link to="/jobwechsel-rechner" className="hover:underline underline-offset-4">Jobwechsel</Link>
          <Link to="/pendel-atlas" className="hover:underline underline-offset-4">Atlas</Link>
        </nav>
        <Link
          to="/#calculator"
          data-testid="header-cta"
          className="hidden sm:inline-flex items-center gap-1.5 bg-neutral-900 text-white text-xs uppercase tracking-widest px-4 h-10 hover:bg-black"
        >
          Jetzt berechnen
          <ArrowUpRight size={14} weight="bold" />
        </Link>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="mt-24 border-t border-neutral-200 bg-neutral-50" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-neutral-900 text-white flex items-center justify-center">
              <Compass size={18} weight="bold" />
            </div>
            <span className="font-display text-xl tracking-tight">PendelPilot</span>
          </div>
          <p className="mt-4 text-sm text-neutral-600 max-w-xs">
            Bessere finanzielle Entscheidungen zum Arbeitsweg — in 30 Sekunden. Kostenlos, ohne Anmeldung.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">Rechner</div>
          <ul className="space-y-2 text-sm">
            {FEATURED_SEO_LIST.map((p) => (
              <li key={p.slug}>
                <Link to={`/${p.slug}`} className="hover:underline">{p.h1}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">Mehr</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pendel-atlas" className="hover:underline">Pendel-Atlas Deutschland</Link></li>
            <li><Link to="/pendlerpauschale-rechner" className="hover:underline">Pendlerpauschale-Rechner</Link></li>
            <li><Link to="/pendeln-kosten-pro-monat" className="hover:underline">Kosten pro Monat</Link></li>
            <li><Link to="/auto-finanzieren-rechner" className="hover:underline">Auto finanzieren</Link></li>
            <li><Link to="/fuer-arbeitgeber" className="hover:underline font-medium">Für Arbeitgeber →</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">Rechtliches</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/datenschutz" className="hover:underline">Datenschutz</Link></li>
            <li><Link to="/impressum" className="hover:underline">Impressum</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-200 py-6 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} PendelPilot · Diese Berechnung ersetzt keine Steuer- oder Finanzberatung.
      </div>
    </footer>
  );
}
